import React from 'react'

import { Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { useMst } from '#state'

const PRICING_TABLE_SRC = 'https://js.stripe.com/v3/pricing-table.js'

const useStripePricingScript = () => {
  React.useEffect(() => {
    if (document.querySelector(`script[src="${PRICING_TABLE_SRC}"]`)) return

    const script = document.createElement('script')
    script.src = PRICING_TABLE_SRC
    script.async = true
    document.head.appendChild(script)
  }, [])
}

export const StripePricingTable = observer(function StripePricingTable({
  customerSessionClientSecret,
}: {
  customerSessionClientSecret?: string
}) {
  const { user, environment } = useMst()
  useStripePricingScript()

  const {
    STRIPE_PRICING_TABLE_ID,
    STRIPE_RESUBSCRIBE_PRICING_TABLE_ID,
    STRIPE_PUBLISHABLE_KEY,
  } = environment.config

  const pricingTableId = customerSessionClientSecret
    ? STRIPE_RESUBSCRIBE_PRICING_TABLE_ID
    : STRIPE_PRICING_TABLE_ID

  if (!pricingTableId || !STRIPE_PUBLISHABLE_KEY) {
    return (
      <Text c="dimmed">
        Plans are not available in this environment.{' '}
        <a href="mailto:hello@scripto.live">Contact us</a> to upgrade.
      </Text>
    )
  }

  return (
    <stripe-pricing-table
      pricing-table-id={pricingTableId}
      publishable-key={STRIPE_PUBLISHABLE_KEY}
      client-reference-id={user.id}
      customer-email={customerSessionClientSecret ? undefined : user.email}
      customer-session-client-secret={customerSessionClientSecret}
    />
  )
})
